<app-loading-overlay [isLoading]="isSavingDraft || isSubmittingQuery"></app-loading-overlay>
<section class="segment-templates-wrapper">
  <div class="content-panel">
    <div class="panel-body">
      <form nz-form nzLayout="vertical" [formGroup]="segmentForm">
        <div nz-row [nzGutter]="[16, 24]">
          <div nz-col class="gutter-row" [nzSpan]="12">
            <nz-form-item>
              <nz-form-label [nzRequired]="true" nzFor="segmentName" class="nfl-form-label">Segment Name</nz-form-label>
              <nz-form-control [nzErrorTip]="nameErrorTemplate">
                <input
                  formControlName="segmentName"
                  nz-input
                  id="segmentName"
                  placeholder="Enter Segment Name"
                  appTrimFormInput
                  maxlength="50"
                />
              </nz-form-control>
            </nz-form-item>
            <ng-template #nameErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Please enter the segment name</div>
              <div *ngIf="control?.errors?.['minlength']">
                Name must be at least
                {{ control?.errors?.['minlength'].requiredLength }} characters long.
              </div>
              <div *ngIf="control?.errors?.['maxlength']">
                Name cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
              <div *ngIf="control?.errors?.['pattern']">
                Name should not contain any special characters and should have at least one alphabet.
              </div>
            </ng-template>
          </div>
          <div nz-col class="gutter-row" [nzSpan]="12">
            <nz-form-item>
              <nz-form-label [nzRequired]="true" nzFor="segmentDesc" class="nfl-form-label">
                Segment Description
              </nz-form-label>
              <nz-form-control [nzErrorTip]="descriptionErrorTemplate">
                <input
                  formControlName="segmentDesc"
                  nz-input
                  id="segmentDesc"
                  placeholder="Enter Segment Description"
                  appTrimFormInput
                  maxlength="100"
                />
              </nz-form-control>
            </nz-form-item>
            <ng-template #descriptionErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Please enter the segement description.</div>
              <div *ngIf="control?.errors?.['maxlength']">
                Description cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
              <div *ngIf="control?.errors?.['pattern']">Description should contain at least one alphabet</div>
            </ng-template>
          </div>
        </div>
        <nz-collapse class="collapse-section" nzExpandIconPosition="end" nzSize="small">
          <nz-collapse-panel nzHeader="Select Table(s)" nzActive="true" nzDisabled="false" nzExpandedIcon="plus">
            <div nz-row [nzGutter]="[16, 24]">
              <div nz-col class="gutter-row" [nzSpan]="8">
                <nz-form-item>
                  <nz-form-label [nzRequired]="true" nzFor="dataSource" class="nfl-form-label"
                    >Data Source</nz-form-label
                  >
                  <nz-form-control [nzErrorTip]="datasourceErrorTemplate">
                    <nz-select
                      nzPlaceHolder="Select Data Source"
                      nzMode="multiple"
                      nzSize="default"
                      [nzMaxTagCount]="2"
                      [nzMaxTagPlaceholder]="datasourcePlaceholder"
                      [formControl]="selectedDatasources"
                      [nzDisabled]="isMetadataLoading || !dataSourceList.length"
                    >
                      <nz-option
                        [nzLabel]="datasource"
                        [nzValue]="datasource"
                        *ngFor="let datasource of dataSourceList; index as i"
                      ></nz-option>
                    </nz-select>
                    <ng-template #datasourcePlaceholder let-selectedList>
                      and {{ selectedList.length }} more selected
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
                <ng-template #datasourceErrorTemplate let-control>
                  <div *ngIf="control?.errors?.['required']">Data Source selection is required</div>
                </ng-template>
              </div>
              <div nz-col class="gutter-row" [nzSpan]="8">
                <nz-form-item>
                  <nz-form-label [nzRequired]="true" nzFor="database" class="nfl-form-label"> Database </nz-form-label>
                  <nz-form-control [nzErrorTip]="databaseErrorTemplate">
                    <nz-select
                      nzPlaceHolder="Select Database"
                      nzMode="multiple"
                      nzSize="default"
                      [nzMaxTagPlaceholder]="databasePlaceholder"
                      [formControl]="selectedDatabases"
                    >
                      <nz-option
                        *ngFor="let database of databaseList; index as i"
                        [nzLabel]="database"
                        [nzValue]="database"
                      ></nz-option>
                    </nz-select>
                    <ng-template #databasePlaceholder let-selectedList>
                      and {{ selectedList.length }} more selected
                    </ng-template>
                  </nz-form-control>
                  <ng-template #databaseErrorTemplate let-control>
                    <div *ngIf="control?.errors?.['required']">Database selection is required</div>
                  </ng-template>
                </nz-form-item>
              </div>
              <div nz-col class="gutter-row" [nzSpan]="8">
                <nz-form-item>
                  <nz-form-label [nzRequired]="true" nzFor="baseTable" class="nfl-form-label">
                    Base Table
                  </nz-form-label>
                  <nz-form-control>
                    <nz-select
                      nzPlaceHolder="Select Base Table"
                      formControlName="baseTable"
                      id="baseTable"
                      nzSize="default"
                    >
                      <nz-option
                        [nzLabel]="item.tableName"
                        [nzValue]="item.tableName"
                        *ngFor="let item of tableList; index as i"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
        <nz-collapse nzExpandIconPosition="end" nzSize="small">
          <nz-collapse-panel nzHeader="Add Conditions" nzActive="true" nzDisabled="false" nzExpandedIcon="plus">
            <div class="add-action-buttons">
              <button nz-button nzType="default" nzSize="large" nzSuccess (click)="addSingleRow()">
                Add Conditions
              </button>
              <button nz-button nzType="default" nzSize="large" nzSuccess (click)="addGroup()">Add Group</button>
            </div>

            <div formArrayName="singleRows" class="single-rows-wrapper">
              <ng-container *ngFor="let row of singleRows.controls; let i = index">
                <nz-card>
                  <div nz-row [nzGutter]="[16, 24]" [formGroupName]="i">
                    <div nz-col class="gutter-row" nzSpan="7">
                      <nz-form-item class="dynamic-input-field">
                        <nz-form-control [nzErrorTip]="conditionColumnErrorTemplate">
                          <nz-select formControlName="column">
                            <nz-option
                              [nzLabel]="item.name ?? ''"
                              [nzValue]="item.name ?? ''"
                              *ngFor="let item of columnList; index as i"
                            ></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div nz-col class="gutter-row" nzSpan="7">
                      <nz-form-item class="dynamic-input-field">
                        <nz-form-control>
                          <nz-select formControlName="op">
                            <nz-option
                              [nzLabel]="item.name"
                              [nzValue]="item.value"
                              *ngFor="let item of operatorsOptions; index as i"
                            ></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div nz-col class="gutter-row" class="gutter-row" nzSpan="7">
                      <nz-form-item class="dynamic-input-field">
                        <nz-form-control [nzErrorTip]="conditionValueErrorTemplate">
                          <input nz-input placeholder="Value" formControlName="value" />
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div nz-col class="gutter-row" nzOffset="1" class="gutter-row" nzSpan="2">
                      <span nz-icon nzType="delete" class="delete-row-icon" (click)="deleteRow(singleRows, i)"></span>
                    </div>
                  </div>
                </nz-card>
                <div class="operator-panel" *ngIf="i < singleRows.length - 1" [formGroupName]="i">
                  <nz-segmented formControlName="operator" [nzOptions]="booleanOperatorOptions"></nz-segmented>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="singleRows.length > 0 && groups.length > 0 && getLastSingleRowGroup() as lastRowGroup">
              <div [formGroup]="segmentForm" class="operator-panel">
                <nz-segmented formControlName="operator" [nzOptions]="booleanOperatorOptions"></nz-segmented>
              </div>
            </ng-container>

            <div formArrayName="groups">
              <ng-container *ngFor="let group of groups.controls; let gi = index">
                <div [formGroupName]="gi">
                  <!-- group UI -->
                  <ng-container
                    *ngTemplateOutlet="
                      groupTemplate;
                      context: {
                        $implicit: group,
                        parent: groups,
                        index: gi,
                      }
                    "
                  ></ng-container>

                  <div class="operator-panel" *ngIf="gi < groups.length - 1" class="operator-ui">
                    <nz-segmented formControlName="operator" [nzOptions]="booleanOperatorOptions"></nz-segmented>
                  </div>
                </div>
              </ng-container>
            </div>

            <ng-template #conditionColumnErrorTemplate let-control>
              <div *ngIf="getConditionColumnError(control) as error">{{ error }}</div>
            </ng-template>

            <ng-template #conditionValueErrorTemplate let-control>
              <div *ngIf="getConditionValueError(control) as error">{{ error }}</div>
            </ng-template>
          </nz-collapse-panel>
        </nz-collapse>
      </form>
    </div>
  </div>

  <div class="footer-action">
    <button
      nz-button
      nzType="default"
      nzSize="large"
      nzSuccess
      class="generate-button disabled-btn"
      [disabled]="isButtonDisabled || isSavingDraft || isSubmittingQuery"
      [nzLoading]="isSavingDraft || isSubmittingQuery"
      (click)="onGenerateDataClick()"
    >
      Generate Data
    </button>
  </div>
</section>

<ng-template #groupTemplate let-group let-parentGroups="parent" let-groupIndex="index">
  <div [formGroup]="group" class="group-container">
    <!-- Group Header -->
    <div class="group-header">
      <button nz-button nzType="default" (click)="addRowToGroup(group)" class="add-condition-button">
        Add Conditions
      </button>

      <button nz-button nzType="default" (click)="addNestedGroup(group)">Add Group</button>
    </div>

    <!-- Rows -->
    <div formArrayName="rows">
      <ng-container *ngFor="let row of getRows(group).controls; let ri = index">
        <nz-card>
          <div [formGroupName]="ri" nz-row [nzGutter]="[16, 24]">
            <div nz-col nzSpan="7">
              <nz-form-item class="dynamic-input-field">
                <nz-form-control [nzErrorTip]="conditionColumnErrorTemplate">
                  <nz-select formControlName="column" nzPlaceHolder="Select column">
                    <nz-option
                      *ngFor="let item of columnList; index as i"
                      [nzLabel]="item.name ?? ''"
                      [nzValue]="item.name ?? ''"
                    >
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="7">
              <nz-form-item class="dynamic-input-field">
                <nz-form-control>
                  <nz-select formControlName="op">
                    <nz-option
                      [nzLabel]="item.name"
                      [nzValue]="item.value"
                      *ngFor="let item of operatorsOptions; index as i"
                    ></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="7">
              <nz-form-item class="dynamic-input-field">
                <nz-form-control [nzErrorTip]="conditionValueErrorTemplate">
                  <input nz-input placeholder="Value" formControlName="value" />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzOffset="1" nzSpan="2">
              <span
                nz-icon
                nzType="delete"
                class="delete-row-icon"
                (click)="deleteRow(getRows(group), ri, parentGroups, groupIndex)"
              ></span>
            </div>
          </div>
        </nz-card>

        <div *ngIf="showOperatorAfterRow(group, ri)" [formGroupName]="ri" class="operator-panel">
          <nz-segmented formControlName="operator" [nzOptions]="booleanOperatorOptions"></nz-segmented>
        </div>
      </ng-container>
    </div>

    <div formArrayName="groups">
      <ng-container *ngFor="let child of getGroups(group).controls; let ci = index">
        <div [formGroupName]="ci">
          <ng-container
            *ngTemplateOutlet="
              groupTemplate;
              context: {
                $implicit: child,
                parent: getGroups(group),
                index: ci,
              }
            "
          ></ng-container>

          <div class="operator-panel" *ngIf="ci < getGroups(group).length - 1" class="operator-ui">
            <nz-segmented formControlName="operator" [nzOptions]="booleanOperatorOptions"></nz-segmented>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
